export default __webpack_public_path__ + "static/media/sofianee.b6ae636c.png";